/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PfxPasswordDto
 */
export interface PfxPasswordDto {
    /**
     * PFX password
     * @type {string}
     * @memberof PfxPasswordDto
     */
    pfxPassword: string;
}

/**
 * Check if a given object implements the PfxPasswordDto interface.
 */
export function instanceOfPfxPasswordDto(value: object): value is PfxPasswordDto {
    if (!('pfxPassword' in value) || value['pfxPassword'] === undefined) return false;
    return true;
}

export function PfxPasswordDtoFromJSON(json: any): PfxPasswordDto {
    return PfxPasswordDtoFromJSONTyped(json, false);
}

export function PfxPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PfxPasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pfxPassword': json['pfxPassword'],
    };
}

export function PfxPasswordDtoToJSON(value?: PfxPasswordDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pfxPassword': value['pfxPassword'],
    };
}

